import { render } from "./QuestionnairePreview.vue?vue&type=template&id=22422549&scoped=true"
import script from "./QuestionnairePreview.vue?vue&type=script&lang=js"
export * from "./QuestionnairePreview.vue?vue&type=script&lang=js"

import "./QuestionnairePreview.vue?vue&type=style&index=0&id=22422549&lang=less&scoped=true"

import exportComponent from "E:\\Code\\TECS\\TECS-FE-ENDUSER-NEW\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22422549"]])

export default __exports__